const formatCurrency = (value) => {
    return value ? (value / 100).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ' ') : 0;
};

export default formatCurrency;
